import React from "react"

import { AppAcrissAutocomplete } from "@components"
import { useUserSettingsAcriss, useUserSettingsAcrissValidator } from "../../../@hooks"
import { userSettingAcrissFormData } from "../../../@signals"


export default function UserSettingAcrissDrawerAcriss() {
	const { handleChangeAcrissFormData } = useUserSettingsAcriss()
	const { acrissError } = useUserSettingsAcrissValidator()

    return <AppAcrissAutocomplete
		label="ACRISS"
		disableClearable
		multiple={false}
		placeholder="Select ACRISS"
		error={acrissError}
		value={userSettingAcrissFormData.value?.acriss_code || ''}
		onChange={e => handleChangeAcrissFormData(e.target.value, 'acriss_code')}
	/>
}